<div mat-dialog-content>
  <div class="mat-dialog-content">
    @if (data.hasImage) {
      <div class="head-confirm-modal-list">
        <div class="img-head">
          <img src="assets/images/exclamation-circle.png" />
        </div>
        <div class="title-modal">
          <h1>{{title}}</h1>
        </div>
        @if (!highlightedText) {
          <div class="body-modal">
            {{description}}
          </div>
        }
        @if (highlightedText) {
          <div class="body-modal">
            {{ description }} <b>{{ highlightedText }}</b>
            @if (description2) {
              <p>{{ description2 }}</p>
            }
          </div>
        }
      </div>
    }
    @if (!data.hasImage) {
      <div>
        <div class="title-modal">
          <h1>{{title}}</h1>
        </div>
        @if (!highlightedText) {
          <div class="body-modal">
            {{description}}
          </div>
        }
        @if (highlightedText) {
          <div class="body-modal">
            {{ description }} <b>{{ highlightedText }}</b>
            @if (description2) {
              <p>{{ description2 }}</p>
            }
          </div>
        }
      </div>
    }
    @if (!data.isTwoButtonsModal && !data.hasImage) {
      <div class="btn-container">
        <button mat-flat-button color="primary" class="button-close-modal"
        (click)="close()">{{textButtonCancel}}</button>
      </div>
    }
    @if (!data.isTwoButtonsModal && data.hasImage) {
      <div class="btn-container">
        <div class="row">
          <div class="col-12">
            <button mat-flat-button color="primary" class="button-close-modal-other"
            (click)="close()">{{textButtonCancel}}</button>
          </div>
        </div>
      </div>
    }
    @if (this.data.isTwoButtonsModal) {
      <div class="btn-container">
        <button mat-flat-button color="accent" class="button-close-modal"
        (click)="confirm()">{{this.textButtonConfirm}}</button>
        <button mat-flat-button color="primary" class="button-close-modal"
        (click)="cancel()">{{this.textButtonCancel}}</button>
      </div>
    }
  </div>
</div>